import { Controller } from '@hotwired/stimulus';

// Reloads the surrounding turbo frame on an interval, for server state that
// changes without a user action (a running background job). The server stops
// the polling simply by rendering the frame without this controller.
export default class extends Controller {
  static values = { interval: { type: Number, default: 2000 } };

  connect() {
    this.frame = this.element.closest('turbo-frame');
    if (!this.frame) return;

    this.timer = setInterval(() => this.frame.reload(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }
}
